import {HTMLDialogElement} from "@dooboostore/dom-parser";

/**
 * Global type augmentation for @dooboostore showcase
 */
declare global {
  interface Window {
    Node: typeof Node;
    NodeList: typeof NodeList;
    Element: typeof Element;
    HTMLElement: typeof HTMLElement;
    HTMLDivElement: typeof HTMLDivElement;
    HTMLButtonElement: typeof HTMLButtonElement;
    HTMLTemplateElement: typeof HTMLTemplateElement;
    HTMLAnchorElement: typeof HTMLAnchorElement;
    HTMLDialogElement: typeof HTMLDialogElement;
    HTMLBodyElement: typeof HTMLBodyElement;
    HTMLSectionElement: typeof HTMLSectionElement;
    HTMLMainElement: typeof HTMLMainElement;
    ShadowRoot: typeof ShadowRoot;
    location: Location;
    document: Document;
    history: History;
    console: Console;
    IntersectionObserver: typeof IntersectionObserver;
    ResizeObserver: typeof ResizeObserver;
    MutationObserver: typeof MutationObserver;
    SwaggerUIBundle: any;

  }
}

export {};
